export const MODAL_OPENED = 'MODAL/OPENED';

export interface ModalOpened {
  type: typeof MODAL_OPENED;
  payload: {
    title: string;
  };
}

export const MODAL_BUTTON_CLICK = 'MODAL/BUTTON_CLICK';

export interface ModalButtonClick {
  type: typeof MODAL_BUTTON_CLICK;
  payload: {
    title: string;
    actionLabel: string;
  };
}

export type AnalyticsEvents = ModalOpened | ModalButtonClick;
